const TOPICS = [
    {
        title: "Relacionamentos",
        body: "Reconstruir vínculos, criar comunicação verdadeira e nutrir presença afetiva — com o outro e consigo.",
    },
    {
        title: "Ansiedade",
        body: "Quando o pensamento corre adiante do corpo. Aprender a regular o que sente e voltar ao presente com clareza.",
    },
    {
        title: "Conflitos emocionais",
        body: "Dar nome ao que dói. Olhar para o que se evita e descobrir o que existe por baixo da sobrecarga.",
    },
    {
        title: "Comunicação",
        body: "Sair do automático: aprender a pedir, escutar, negociar e expressar — sem perder a si mesmo.",
    },
    {
        title: "Sobrecarga",
        body: "Para quem carrega demais por tempo demais. Recuperar o ritmo, o descanso e o direito ao próprio limite.",
    },
    {
        title: "Reconexão consigo",
        body: "Reencontrar valores, prazer e propósito. Voltar a habitar a própria vida com mais inteireza.",
    },
    {
        title: "Padrões repetitivos",
        body: "Quando histórias parecem se repetir. Compreender a raiz e construir novas formas de estar no mundo.",
    },
    {
        title: "Dificuldades afetivas",
        body: "Medo de intimidade, ciúme, dependência, distância. Movimentos do amor que merecem espaço para serem cuidados.",
    },
];

export const HowItHelps = () => {
    return (
        <section id="terapia" data-testid="how-it-helps-section" className="py-24 lg:py-32 bg-[#D8B7B1]/25 relative">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 items-end">
                    <div className="lg:col-span-7 reveal">
                        <p className="overline mb-5">Como a terapia pode ajudar</p>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.08] text-[#2F2F2F]">
                            Há temas que pedem
                            <span className="italic text-[#9f1e1e]"> uma escuta dedicada </span>
                            para serem compreendidos.
                        </h2>
                    </div>
                    <div className="lg:col-span-5 reveal reveal-delay-1">
                        <p className="text-base lg:text-lg leading-relaxed text-[#2F2F2F]/80">
                            O processo terapêutico não te pede para ter respostas prontas. Ele oferece o tempo,
                            o método e o cuidado para que você encontre as suas — com mais consciência,
                            liberdade e gentileza.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#B7A6B0]/30 border border-[#B7A6B0]/30">
                    {TOPICS.map((t, i) => (
                        <div
                            key={t.title}
                            data-testid={`topic-card-${i}`}
                            className="bg-[#F5F4F2] p-8 lg:p-9 group hover:bg-[#F5F4F2]/70 transition-colors duration-500 reveal"
                            style={{ animationDelay: `${i * 60}ms` }}
                        >
                            <div className="flex items-baseline gap-3 mb-4">
                                <span className="font-display text-[#9f1e1e]/60 text-sm">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <div className="h-px flex-1 bg-[#B7A6B0]/40 group-hover:bg-[#9f1e1e] transition-colors duration-500" />
                            </div>
                            <h3 className="font-display text-2xl text-[#2F2F2F] mb-3 leading-tight">{t.title}</h3>
                            <p className="text-sm leading-relaxed text-[#2F2F2F]/70">{t.body}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
